import { state } from "./state";
import { defineStoreActions } from "~/stores";
import { id } from "./id";
import { getters } from "./getters";
import { repository } from "~/repository";
import moment from "moment/moment";
import { useAuthStore } from "~/stores/auth/store";
import type { Collection } from "~/types";

export const actions = defineStoreActions(
  {
    id,
    state,
    getters,
  },
  {
    async fetchAndSetBanners() {
      const banners = await repository.common.getBanners();

      this.$patch((state) => {
        state.banners = banners;
      });
    },
    async fetchVideoProgress() {
      const authStore = useAuthStore();
      const { authenticated } = storeToRefs(authStore);

      let tempList = [] as Collection[];

      if (authenticated.value) {
        const { data } = await repository.videos.getProgress();
        const videoProgress = data.videos
          .filter((video) => !video.completed)
          .sort((a, b) => {
            return moment(b.last_watched).diff(moment(a.last_watched));
          });

        tempList = videoProgress;
      }

      this.$patch((state) => {
        state.videoProgress = tempList;
      });
    },
  },
);
